import { ProfileActions } from '~/actions/profile/action'
import { clearAllCaches } from '~/services/cacheRegistry'
import CookieService from '~/services/cookies'
import { useAuthStore } from '~/store/auth'
import { useProfileStore } from '~/store/profile'
import { TranslationService } from '~/services/Translation'
import { useProfileTrips } from '~/store/profileTrips'

export default defineNuxtRouteMiddleware(async (to, from) => {
	if (import.meta.server) return

	const nuxtApp = useNuxtApp()
	TranslationService.getInstance(nuxtApp.$i18n)

	const authCookie = CookieService.getAuthCookie()
	const routeStore = useAuthStore()
	const profileStore = useProfileStore()
	const profileTripsStore = useProfileTrips()

	if (!authCookie?.auth?.accessToken) {
		const redirectPath = to.fullPath || from.fullPath
		const isAuthRoute = redirectPath.includes('/auth/')
		if (!isAuthRoute) routeStore.setPreviousRoute(redirectPath)
		profileStore.resetAll()
		profileTripsStore.resetAll()
		clearAllCaches()
		return navigateTo(`/${nuxtApp.$i18n.locale.value}/auth/login`)
	}

	const profile = await ProfileActions.getProfile()
	if (!profile?.id) {
		CookieService.deleteAuthCookie()
		return navigateTo(`/${nuxtApp.$i18n.locale.value}/auth/login`)
	}
})
